import { apiClient } from './apiClient';

export const getDashboardStats = async () => {
  const response = await apiClient.get('/api/v1/dashboard/stats');
  return response.data?.data || { totalClients: 0, totalProducts: 0 };
};

export const getRecentActivities = async (limit = 20) => {
  const response = await apiClient.get('/api/v1/dashboard/activities', {
    params: { limit },
  });
  return response.data?.data || [];
};
